import React from "react";

export const cookies = {
  showBanner: true,
};
const CookieContext = React.createContext(cookies.showBanner);

export { CookieContext };
